import { imgPreload, selectArea, getDevice } from '@/js/components/common'
import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/css/bundle';
import Cookies from 'js-cookie'
import Modal from '@/js/components/modal'

const setPartnerModalActions = () => {
    const modal = new Modal();
    // 詳細のモーダル表示
    $('[data-modal]').prev('a').on('click', e => {
        const html = $(e.currentTarget).next('[data-modal]').get(0).outerHTML
        modal.setHtml(html)
        modal.show()
        return false
    })
}

const main = () => {
    if (!document.querySelector('#page-home')) return false;

    // selectArea()
    /*
    if ($('.sponsors').length) {
        let deviceMode = null
        let mySwiper

        $(window).resize(() => {
            let slidesPerView
            let nextDeviceMode
            let spaceBetween
            switch (true) {
                case document.body.clientWidth > 1000:
                    slidesPerView = 12
                    spaceBetween = 40
                    nextDeviceMode = "pc"
                    break
                case document.body.clientWidth > 640:
                    slidesPerView = 9.5
                    spaceBetween = 40
                    nextDeviceMode = "tab"
                    break
                default:
                    slidesPerView = 4
                    spaceBetween = 30
                    nextDeviceMode = "sp"
            }

            if (deviceMode == nextDeviceMode) {
                return false
            }
            if (mySwiper !== undefined) mySwiper.destroy(true, true)

            mySwiper = new Swiper('.sponsors', {
                modules: [Autoplay],
                slidesPerView,
                spaceBetween,
                centeredSlides: true,
                loop: true,
                speed: 3000,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false
                },
                freeMode: true,
                freeModeSticky: true,
                grabCursor: true,
                scrollContainer: true,
            })
        }).trigger('resize')
    }
    $('.search-feature .more').on('click', () => {
        $('.search-feature .list').addClass('all')
        return false
    })

    let imgList = [...document.querySelectorAll('.illust img')].map(_node => {
        return _node.getAttribute('src')
    })

    imgPreload(imgList)
        .then(() => {
            document.querySelectorAll('.illust li').forEach((_node, idx) => {
                setTimeout(() => {
                    _node.classList.add('show')
                }, idx * 200)
            })
        })
    */
    // スクロールがある場合のみスクロールボタンを表示
    if (window.innerHeight + 10 < document.body.scrollHeight) {
        document.querySelector('.scroll').dataset.show = '';
    }
    // 10pxスクロールしたらスクロールボタンを非表示
    window.addEventListener('scroll', () => {
        if (window.scrollY > 10) {
            delete document.querySelector('.scroll').dataset.show;
        }
    });
    setPartnerModalActions();
}

export default main;